import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { Dialog, Link, Table, Tag } from 'tdesign-react';
import useTable from '@/hooks/useTable';
import yesPng from './images/check-circle.png';
import noPng from './images/x-circle.png';

export function everyFieldTrue(arr, field) {
  return arr.every((obj) => obj[field] === true);
}

export default function Auth({ authVisible, authData, clusterName, onConfirm, onClose }) {
  const [visible, setVisible] = useState(false);
  const [isAuthed, setIsAuthed] = useState(false);

  const columns = [
    {
      title: '资源名称',
      colKey: 'resourceName',
    },
    {
      title: '资源所需权限',
      colKey: 'permission',
      cell: ({ row }) => (
        <Tag theme='primary' variant='light'>
          {row?.permission}
        </Tag>
      ),
    },
    {
      title: '资源说明',
      colKey: 'explanation',
    },
    {
      title: '是否拥有权限',
      colKey: 'authed',
      cell: ({ row }) => <Icon $yes={row.authed} />,
    },
  ];

  useEffect(() => {
    setVisible(authVisible);
    setData(authData);
    setIsAuthed(everyFieldTrue(authData, 'authed'));
    // eslint-disable-next-line
  }, [authVisible, authData]);

  const { config, setData } = useTable({
    columns,
    searchButton: null,
  });

  const handleConfirm = () => {
    setVisible(false);
    onConfirm(isAuthed);
  };

  const handleClose = () => {
    setVisible(false);
    onClose();
  };

  return (
    <>
      <Dialog
        visible={visible}
        width='80%'
        header='权限检查'
        confirmBtn={{ content: '确定', disabled: !isAuthed }}
        placement='center'
        onClose={handleClose}
        onConfirm={handleConfirm}
      >
        {!isAuthed && (
          <Title>
            权限检查未通过，需自行配置相关权限，请
            <Link
              theme='primary'
              style={{ fontSize: 14 }}
              onClick={() => {
                window.open(`/cluster/permissions/roles?name=${clusterName}`);
              }}
            >
              前往
            </Link>
          </Title>
        )}
        <Table {...config} />
      </Dialog>
    </>
  );
}

const Icon = styled.div`
  width: 20px;
  height: 22px;
  background-image: url(${(props) => (props.$yes ? yesPng : noPng)});
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  margin-left: 4px;
`;

const Title = styled.div`
  margin-bottom: 12px;
  font-weight: bold;
  font-size: 14px;
  line-height: 22px;
  padding-right: 3px;
  color: #0d111a;
`;
